<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card-actions
          :action-collapse="true"
          title="جزئیات محصول"
        >
          <b-form
            ref="productform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="6"
                offset-md="3"
              >
                <b-tabs>
                  <b-tab
                    active
                  >
                    <template #title>
                      <span class="d-none d-sm-inline">اطلاعات کلی</span>
                    </template>
                    <b-row>
                      <b-col
                        class="image"
                        cols="12"
                      >
                        <b-media class="mb-2">
                          <template #aside>
                            <b-avatar
                              ref="previewEl"
                              :src="Form.Image"
                              size="90px"
                              rounded
                              button
                              @click="$refs.refInputEl.click()"
                            />
                          </template>
                          <input
                            :ref="'refInputEl'"
                            type="file"
                            class="d-none"
                            name="Image"
                            @input="imageRenderer($event)"
                          >
                          <b-row>
                            <b-col md="12">
                              <b-form-group
                                label="عنوان"
                                label-for="Title"
                                class="mb-0"
                              >
                                <b-form-input
                                  id="Title"
                                  v-model="Form.Title"
                                  name="Title"
                                  autocomplete="off"
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-media>
                      </b-col>

                      <b-col md="12">
                        <b-form-group
                          label="زیرنویس"
                          label-for="Caption"
                        >
                          <b-form-input
                            v-model="Form.Caption"
                            autocomplete="off"
                            name="Caption"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="12">
                        <b-form-group
                          label="پیوند یکتا"
                          label-for="Slug"
                        >
                          <b-form-input
                            id="Sort"
                            v-model="Form.Slug"
                            name="Slug"
                            autocomplete="off"
                            dir="ltr"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          label="دسته بندی اصلی"
                          label-for="ProductCategoryId"
                        >
                          <product-category
                            v-model="Form.ProductCategoryId"
                            :multiple="false"
                            :clearable="false"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          label="برند"
                          label-for="BrandId"
                        >
                          <brand
                            v-model="Form.BrandId"
                            :multiple="false"
                            :clearable="false"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          label="گارانتی"
                          label-for="GuarantyId"
                        >
                          <guaranty
                            v-model="Form.GuarantyId"
                            :multiple="false"
                            :clearable="true"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="12">
                        <b-form-group
                          label="سایر دسته بندی ها"
                          label-for="ProductCategoryId"
                        >
                          <product-category
                            v-model="Form.OtherProductCategoryId"
                            :multiple="true"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        cols="12"
                        class="mt-50"
                      >
                        <b-form-group>
                          <b-form-checkbox
                            v-model="Form.IsCustom"
                            name="IsCustom"
                            value="true"
                            class="custom-control-primary"
                          >
                            محصول سفارشی می باشد.
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <b-col
                        cols="12"
                        class="mt-50"
                      >
                        <b-form-group>
                          <b-form-checkbox
                            v-model="Form.ShowInHome"
                            name="ShowInHome"
                            value="true"
                            class="custom-control-primary"
                          >
                            در صفحه اصلی نمایش داده شود.
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <b-col
                        cols="12"
                        class="mt-50"
                      >
                        <b-form-group>
                          <b-form-checkbox
                            v-model="Form.HasVariety"
                            name="HasVariety"
                            value="true"
                            class="custom-control-primary"
                          >
                            محصول دارای تنوع رنگی می باشد.
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <b-col
                        cols="12"
                        class="mt-50 mb-50"
                      >
                        <b-form-group>
                          <b-form-checkbox
                            v-model="Form.IsAuction"
                            name="IsAuction"
                            value="true"
                            class="custom-control-primary"
                          >
                            در قسمت تخفیفات باورنکردنی نمایش داده شود.
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          label="وضعیت"
                          label-for="Status"
                        >
                          <v-select
                            v-model="Form.Status"
                            :options="enums('ProductStatus')"
                            dir="rtl"
                            label="text"
                            name="Status"
                            :clearable="false"
                            :reduce="x => x.value"
                            :disabled="Form.HasVariety"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          label="قیمت"
                          label-for="Price"
                        >
                          <b-input-group append="تومان">
                            <cleave
                              v-model="Form.Price"
                              class="form-control"
                              :raw="false"
                              :options="options"
                              :disabled="Form.HasVariety"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          label="تخفیف"
                          label-for="Discount"
                        >
                          <b-input-group append="تومان">
                            <cleave
                              v-model="Form.Discount"
                              class="form-control"
                              :raw="false"
                              :options="options"
                              :disabled="Form.HasVariety"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          label="تعداد"
                          label-for="Quantity"
                        >
                          <b-form-input
                            v-model="Form.Quantity"
                            autocomplete="off"
                            type="number"
                            name="Quantity"
                            :disabled="Form.HasVariety"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          label="بارکد"
                          label-for="Barcode"
                        >
                          <b-form-input
                            v-model="Form.Barcode"
                            autocomplete="off"
                            name="Barcode"
                            :disabled="Form.HasVariety"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4" />

                      <b-col md="3">
                        <b-form-group
                          label="حداقل تعداد سفارش"
                          label-for="MinOrderQuantity"
                        >
                          <b-form-input
                            v-model="Form.MinOrderQuantity"
                            autocomplete="off"
                            type="number"
                            name="MinOrderQuantity"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          label="حداکثر تعداد سفارش"
                          label-for="MaxOrderQuantity"
                        >
                          <b-form-input
                            v-model="Form.MaxOrderQuantity"
                            autocomplete="off"
                            type="number"
                            name="MaxOrderQuantity"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          label="زمان آماده سازی"
                          label-for="Preparation"
                        >
                          <b-input-group append="روز">
                            <cleave
                              v-model="Form.Preparation"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          label="هزینه بسته بندی"
                          label-for="PackagingPrice"
                        >
                          <b-input-group append="تومان">
                            <cleave
                              v-model="Form.PackagingPrice"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          label="وزن"
                          label-for="Weight"
                        >
                          <b-input-group append="گرم">
                            <cleave
                              v-model="Form.Weight"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">

                        <b-form-group
                          label="طول"
                          label-for="Length"
                        >
                          <b-input-group append="سانتی‌متر">
                            <cleave
                              v-model="Form.Length"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">
                        <b-form-group
                          label="عرض"
                          label-for="Width"
                        >
                          <b-input-group append="سانتی‌متر">
                            <cleave
                              v-model="Form.Width"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">
                        <b-form-group
                          label="ارتفاع"
                          label-for="Height"
                        >
                          <b-input-group append="سانتی‌متر">
                            <cleave
                              v-model="Form.Height"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                            label="اجرت"
                            label-for="Profit"
                        >
                          <b-input-group append="درصد">
                            <cleave
                                v-model="Form.Profit"
                                class="form-control"
                                :raw="false"
                                :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                            label="سود"
                            label-for="Wage"
                        >
                          <b-input-group append="سود">
                            <cleave
                                v-model="Form.Wage"
                                class="form-control"
                                :raw="false"
                                :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          label="تگ ها"
                          label-for="Tag"
                        >
                          <b-form-tags
                            v-model="Form.Tag"
                            name="Tag"
                            placeholder=""
                            add-button-text="افزودن"
                            add-button-variant="outline-primary"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          label="ویژگی ها"
                          label-for="Attribute"
                        >
                          <b-form-tags
                            v-model="Form.Attribute"
                            name="Attribute"
                            placeholder=""
                            add-button-text="افزودن"
                            add-button-variant="outline-primary"
                            tag-class="product-attribute"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="12">
                        <b-form-group
                          label="خلاصه"
                          label-for="ShortDescription"
                        >
                          <b-form-textarea
                            id="ShortDescription"
                            v-model="Form.ShortDescription"
                            name="ShortDescription"
                            rows="5"
                            no-resize
                          />
                        </b-form-group>
                      </b-col>

                      <z-seo v-model="Form" />

                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      <span class="d-none d-sm-inline">مشخصات</span>
                    </template>
                    <b-row>
                      <b-col cols="12">
                        <div class="divider divider-solid">
                          <div
                            class="divider-text"
                            style="font-weight: 600;"
                          >
                            مشخصات
                          </div>
                        </div>
                      </b-col>

                      <b-col cols="12">
                        <b-row>
                          <b-col
                            md="2"
                          >
                            <b-form-group
                              label="قابل فیلتر"
                            />
                          </b-col>
                          <b-col
                            md="3"
                          >
                            <b-form-group
                              label="عنوان"
                            />
                          </b-col>
                          <b-col
                            md="5"
                          >
                            <b-form-group
                              label="توضیحات"
                            />
                          </b-col>

                        </b-row>
                        <b-row
                          v-for="(item, index) in Form.ProductSpecification"
                          :key="index"
                        >

                          <b-col md="2">
                            <b-form-group>
                              <b-form-checkbox
                                v-model="item.ShowInFilter"
                                class="custom-control-primary"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="3">
                            <b-form-group>
                              <b-form-input
                                v-model="item.Title"
                                autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="5">
                            <b-form-group>
                              <b-form-input
                                v-model="item.Description"
                                autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col
                            md="2"
                            class="mb-1"
                            style="display: flex; align-items: flex-end;"
                          >
                            <template v-if="ProductSpecificationRemoveId !== index">
                              <b-button
                                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger"
                                class="btn-icon rounded-circle"
                                @click="removeProductSpecification(index)"
                              >
                                <feather-icon
                                  icon="TrashIcon"
                                />
                              </b-button>
                            </template>
                            <template v-else>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle"
                                variant="outline-primary"
                                @click="cancelProductSpecification"
                              >
                                <feather-icon icon="XIcon" />
                              </b-button>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle ml-1"
                                variant="outline-primary"
                                @click="confirmProductSpecification"
                              >
                                <feather-icon icon="CheckIcon" />
                              </b-button>
                            </template>
                          </b-col>

                        </b-row>
                      </b-col>

                      <b-col class="mt-50">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="gradient-info"
                          @click="addProductSpecification"
                        >
                          <feather-icon
                            icon="PlusIcon"
                            class="mr-25"
                          />
                          <span>افزودن</span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      <span class="d-none d-sm-inline">نقد و بررسی</span>
                    </template>
                    <b-row>
                      <b-col md="12">
                        <b-form-group
                          label="توضیحات"
                          label-for="Description"
                        >
                          <z-quill-editor v-model="Form.Description" />
                        </b-form-group>

                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      <span class="d-none d-sm-inline">گالری</span>
                    </template>
                    <b-row>
                      <b-col cols="12">
                        <div class="divider divider-solid mb-0">
                          <div
                            class="divider-text"
                            style="font-weight: 600;"
                          >
                            گالری اصلی
                          </div>
                        </div>
                      </b-col>
                      <div
                        v-for="(item, index) in Form.ProductGallery.filter(x=>x.IsSecondary == false)"
                        :key="item.Id"
                        class="px-1 mb-1"
                      >
                        <b-avatar
                          ref="previewEl"
                          :src="item.Url"
                          size="120px"
                          rounded
                          class="foodrecipes-image mt-1"
                        />
                        <b-form-group style="width: 120px;">
                          <b-form-input
                            v-model="item.Title"
                            autocomplete="off"
                            class="mt-1"
                            @click="showModal(item)"
                          />
                        </b-form-group>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          style="margin-top: 0.5rem;"
                          class="btn-icon video-remove"
                          @click="removeGallery(item)"
                        >
                          <feather-icon
                            icon="XIcon"
                            size="14"
                          />
                        </b-button>
                      </div>

                      <input
                        ref="refGalley1"
                        type="file"
                        class="d-none is-primary"
                        accept="image/*"
                        @change="galleryRenderer($event)"
                      >

                      <div class="px-1 mb-1 mt-1">
                        <div
                          class="activity-upload-video"
                          @click="$refs.refGalley1.click()"
                        >
                          <div class="activity-upload-video-icon">
                            <feather-icon
                              size="24"
                              icon="UploadIcon"
                            />
                          </div>
                        </div>
                      </div>

                      <b-col cols="12">
                        <div class="divider divider-solid mb-0">
                          <div
                            class="divider-text"
                            style="font-weight: 600;"
                          >
                            گالری فرعی
                          </div>
                        </div>
                      </b-col>
                      <div
                        v-for="(item, index) in Form.ProductGallery.filter(x=>x.IsSecondary == true)"
                        :key="item.Id"
                        class="px-1 mb-1"
                      >
                        <b-avatar
                          ref="previewEl"
                          :src="item.Url"
                          size="120px"
                          rounded
                          class="foodrecipes-image mt-1"
                        />
                        <b-form-group style="width: 120px;">
                          <b-form-input
                              v-model="item.Title"
                              autocomplete="off"
                              class="mt-1"
                              @click="showModal(item)"
                          />
                        </b-form-group>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          style="margin-top: 0.5rem;"
                          class="btn-icon video-remove"
                          @click="removeGallery(item)"
                        >
                          <feather-icon
                            icon="XIcon"
                            size="14"
                          />
                        </b-button>
                      </div>

                      <input
                        ref="refGalley2"
                        type="file"
                        class="d-none is-secondary"
                        accept="image/*"
                        @change="galleryRenderer($event)"
                      >

                      <div class="px-1 mb-1 mt-1">
                        <div
                          class="activity-upload-video"
                          @click="$refs.refGalley2.click()"
                        >
                          <div class="activity-upload-video-icon">
                            <feather-icon
                              size="24"
                              icon="UploadIcon"
                            />
                          </div>
                        </div>
                      </div>

                    </b-row>
                  </b-tab>
                </b-tabs>
                <b-row>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card-actions>
      </b-col>
    </b-row>

    <b-modal
      v-if="isShowModal"
      v-model="isShowModal"
      ok-title="ذخیره"
      centered
      ok-only
      title="عنوان تصویر"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="saveModal"
    >
      <b-row class="mt-1">
        <b-col md="12">
          <b-form-group>
            <b-form-input
              v-model="row.Title"
              autocomplete="off"
              autofocus
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

  </b-overlay>
</template>

<script>

import ProductCategory from '@/tools/productcategory.vue'
import Brand from '@/tools/brand.vue'
import Guaranty from '@/tools/guaranty.vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import ZQuillEditor from '@/tools/quilleditor.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'ProductDetails',
  components: {
    ZSeo,
    ZQuillEditor,
    BCardActions,
    ProductCategory,
    Brand,
    Guaranty,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        ProductCategoryId: null,
        OtherProductCategoryId: [],
        BrandId: null,
        Weight: null,
        Wage: null,
        Profit: null,
        Stock: null,
        Status: 0,
        ProductGallery: [],
        ProductSpecification: [],
        IsMultiColor: false,
        HasVariety: false,
        IsAuction: false,
        Slug: null,
      },
      GalleryFile: [],
      loading: false,
      galleryId: 0,
      ProductSpecificationRemoveId: null,
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      collapsed: false,
      isShowModal: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.product.add
      if (this.$route.params.id) {
        url = this.$api.product.update
      }

      const formData = new FormData(this.$refs.productform)
      formData.append('Id', this.Form.Id)

      if (this.Form.ProductCategoryId) {
        formData.append('ProductCategoryDetails[0].ProductCategoryId', this.Form.ProductCategoryId)
        formData.append('ProductCategoryDetails[0].IsMain', true)
      }

      this.Form.OtherProductCategoryId.forEach((item, index) => {
        formData.append(`ProductCategoryDetails[${index + 1}].ProductCategoryId`, item)
        formData.append(`ProductCategoryDetails[${index + 1}].IsMain`, false)
      })

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      if (this.Form.BrandId) {
        formData.append('BrandId', this.Form.BrandId)
      }

      if (this.Form.GuarantyId) {
        formData.append('GuarantyId', this.Form.GuarantyId)
      }

      if (this.Form.Price) {
        formData.append('Price', this.Form.Price.replaceAll(',', ''))
      }

      if (this.Form.Discount) {
        formData.append('Discount', this.Form.Discount.replaceAll(',', ''))
      }

      if (this.Form.Weight) {
        formData.append('Weight', this.Form.Weight.replaceAll(',', ''))
      }

      if (this.Form.Length) {
        formData.append('Length', this.Form.Length.replaceAll(',', ''))
      }

      if (this.Form.Width) {
        formData.append('Width', this.Form.Width.replaceAll(',', ''))
      }

      if (this.Form.Height) {
        formData.append('Height', this.Form.Height.replaceAll(',', ''))
      }

      if (this.Form.Preparation) {
        formData.append('Preparation', this.Form.Preparation.replaceAll(',', ''))
      }

      if (this.Form.PackagingPrice) {
        formData.append('PackagingPrice', this.Form.PackagingPrice.replaceAll(',', ''))
      }

      // formData.append('HasVariety', this.Form.HasVariety)
      // formData.append('IsAuction', this.Form.IsAuction)
      if (this.Form.Quantity) {
        formData.append('Quantity', this.Form.Quantity)
      }

      if (this.Form.Wage) {
        formData.append('Wage', this.Form.Wage.replaceAll(',', ''))
      }

      if (this.Form.Profit) {
        formData.append('Profit', this.Form.Profit.replaceAll(',', ''))
      }

      formData.append('Barcode', this.Form.Barcode)

      formData.append('Status', this.Form.Status)

      this.Form.ProductSpecification.forEach((item, index) => {
        if ((item.Title && item.Title.trim()) || (item.Description && item.Description.trim())) {
          formData.append(`ProductSpecification[${index}].Title`, item.Title)
          formData.append(`ProductSpecification[${index}].Description`, item.Description)
          formData.append(`ProductSpecification[${index}].ShowInFilter`, item.ShowInFilter)
        }
      })

      this.Form.ProductGallery.forEach((item, index) => {
        formData.append(`ProductGallery[${index}].Id`, item.Id)
        formData.append(`ProductGallery[${index}].Sort`, index)
        formData.append(`ProductGallery[${index}].IsSecondary`, item.IsSecondary)
        if (item.Title) {
          formData.append(`ProductGallery[${index}].Title`, item.Title)
        }
        if (this.GalleryFile.filter(x => x.Id == item.Id)[0]) {
          formData.append(`ProductGallery[${index}].Url`, this.GalleryFile.filter(x => x.Id == item.Id)[0].Url)
        }
      })

      if (this.Form.Attribute) {
        this.Form.Attribute.forEach((item, index) => {
          formData.append(`ProductAttribute[${index}].Title`, item)
        })
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    galleryRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.galleryId++

        if (event.srcElement.classList.contains('is-secondary')) {
          this.Form.ProductGallery.push({ Url: fileReader.result, Id: this.galleryId, IsSecondary: true })
          this.GalleryFile.push({ Url: event.target.files[0], Id: this.galleryId, IsSecondary: true })
        } else {
          this.Form.ProductGallery.push({ Url: fileReader.result, Id: this.galleryId, IsSecondary: false })
          this.GalleryFile.push({ Url: event.target.files[0], Id: this.galleryId, IsSecondary: false })
        }
      }
    },
    removeGallery(item) {
      this.Form.ProductGallery = this.Form.ProductGallery.filter(x => x.Id !== item.Id)
    },
    addProductSpecification() {
      this.Form.ProductSpecification.push({
        Title: null, Description: null, ShowInFilter: false,
      })
    },
    removeProductSpecification(index) {
      this.ProductSpecificationRemoveId = index
    },
    confirmProductSpecification() {
      this.Form.ProductSpecification.splice(this.ProductSpecificationRemoveId, 1)
      this.ProductSpecificationRemoveId = null
    },
    cancelProductSpecification() {
      this.ProductSpecificationRemoveId = null
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.product.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data

          this.Form.ProductCategoryId = this.Form.ProductCategoryDetails.filter(x => x.IsMain)[0].ProductCategoryId
          this.Form.OtherProductCategoryId = this.Form.ProductCategoryDetails.filter(x => x.IsMain == false).map(item => item.ProductCategoryId)
          if (this.Form.ProductAttribute.length) {
            this.Form.Attribute = this.Form.ProductAttribute.map(item => item.Title)
          }

          if (this.Form.ProductGallery.length) {
            this.galleryId = this.Form.ProductGallery.sort((a, b) => b.Id - a.Id)[0].Id

            this.Form.ProductGallery.sort((a, b) => a.Sort - b.Sort)
          }
        })
    },
    showModal(row) {
      this.isShowModal = true
      this.row = row
    },
    saveModal() {
      this.isShowModal = false
    },
  },
}
</script>

<style scoped>
.image .media-body {
    align-self: flex-end;
}
</style>
